import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { CreateBudgetRequestDTO, RequestBudgetResponse } from "@/types";

async function createBudget(
  request: CreateBudgetRequestDTO
): Promise<RequestBudgetResponse> {
  const response = await httpRequest.post<RequestBudgetResponse>(
    `/budgets`,
    request
  );
  return response.data;
}

export function useCreateBudgetMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBudget,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budgets"] });
    },
  });
}
